var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Inbox = function Inbox(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm2 0a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6h-2a1 1 0 0 0-.707.293L13.586 15h-3.172l-2.707-2.707A1 1 0 0 0 7 12H5V6Zm14 8v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4h1.586l2.707 2.707A1 1 0 0 0 10 17h4a1 1 0 0 0 .707-.293L17.414 14H19Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Inbox;